import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "slot"]

  connect() {
    this.nextIndex = this.slotTargets.length
    this.refresh()
  }

  slotTargetConnected() {
    if (this.connected) this.refresh()
  }

  add() {
    const html = this.templateTarget.innerHTML.replaceAll(
      "__INDEX__",
      String(this.nextIndex++),
    )
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.target
      .closest('[data-contacts--language-slots-target="slot"]')
      ?.remove()
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
    this.refresh()
  }

  refresh() {
    this.connected = true
    const selects = this.slotTargets
      .map((slot) => slot.querySelector("select"))
      .filter(Boolean)
    const chosen = selects.map((select) => select.value)

    selects.forEach((select, index) => {
      const taken = new Set(chosen.filter((value, j) => j !== index && value))
      const tomSelect = select.tomselect
      for (const option of select.options) {
        if (!option.value) continue
        const disabled = taken.has(option.value)
        option.disabled = disabled
        tomSelect?.updateOption(option.value, {
          value: option.value,
          text: option.text,
          disabled,
        })
      }
      tomSelect?.refreshOptions(false)
    })
  }
}
